<template>
<div class="chapter">
<div class="inner_page">
<p class="center1"><a id="also"></a><a id="page_ii"></a>A<span class="small">LSO BY</span> P. J. O’R<span class="small">OURKE</span></p>
<p class="center1">Modern Manners</p>
<p class="center">The Bachelor Home Companion</p>
<p class="center">Republican Party Reptile</p>
<p class="center">Holidays in Hell</p>
<p class="center">Parliament of Whores</p>
<p class="center">Give War a Chance</p>
<p class="center">All the Trouble in the World</p>
<p class="center">Age and Guile Beat Youth, Innocence, and a Bad Haircut</p>
<p class="center">Eat the Rich</p>
<p class="center">The CEO of the Sofa</p>
<p class="center">Peace Kills</p>
<p class="center">On The Wealth of Nations</p>
<p class="center">Driving Like Crazy</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also.vue?5a49d8f2